// extracted by mini-css-extract-plugin
export var videoHero = "_dx-4";
export var videoHeroImage = "_dx-5";
export var videoHeroOverlay = "_dx-6";
export var videoHeroSubtitle = "_dx-8";
export var videoHeroText = "_dx-7";
export var videoLauncher = "_dx-0";
export var videoLauncherIcon = "_dx-1";
export var videoLauncherSubtitle = "_dx-3";
export var videoLauncherTitle = "_dx-2";
export var videoPlayer = "_dx-a";
export var videoPlayerWrap = "_dx-9";